import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import Button from '../../../../../components/Button';
import { FieldErrorText, FormControlContainer, FormControlLabel } from '../../../../../components/Layout';
import { ModalFooterContainer } from '../../../../../components/Modal';
import TextField from '../../../../../components/TextField';

const Container = styled.div`
  width: 350px;
`;

interface Props {
  isProcessing: boolean;
  cancelButtonHandler: () => void;
  onSubmit: (officeServer: string) => void;
}

const validIPRegex = /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/;

export default function CreateModalContent(props: Props) {
  const { isProcessing, cancelButtonHandler, onSubmit } = props;

  const [officeServer, setOfficeServer] = useState('');

  const [showFormErrors, setShowFormErrors] = useState(false);

  const isOfficeServerValid = validIPRegex.test(officeServer);

  const createButtonHandler = () => {
    setShowFormErrors(true);

    if (!isOfficeServerValid) return;
    
    onSubmit(officeServer);
  };


  return (
    <Container>
      <FormControlContainer>
        <FormControlLabel>Server IP</FormControlLabel>
        <TextField
          id="create-server-input"
          value={officeServer}
          error={!isOfficeServerValid && showFormErrors}
          onValueChange={(val) => setOfficeServer(val)}
        />
        {!isOfficeServerValid && showFormErrors && (
          <FieldErrorText>Please provide a valid IP address format (xxx.xxx.xxx.xxx)</FieldErrorText>
        )}
      </FormControlContainer>

      <ModalFooterContainer>
        <Button
          id="cancel-create-server-button"
          className="secondary"
          text="Cancel"
          style={{ width: "100%" }}
          onClick={cancelButtonHandler}
        />

        <Button
          id="confirm-create-server-button"
          text="Create"
          style={{ width: "100%" }}
          onClick={createButtonHandler}
          loading={isProcessing}
        />
      </ModalFooterContainer>
    </Container>
  );
}